import React, { Component } from "react";
import { connect } from "react-redux";
import { loadLiterals } from "../../redux/reducers";
import loadLang from "../../i18n/i18n";
import WebChatHeader from "../WebChatHeaderComponent/WebChatHeader";
import WebChat from "../WebChatComponent/WebChat";
import { ENGLISH, ARABIC } from "../../shared/supportedLanguages";
import { APPLICATION_JSON } from "../../shared/sharedConsts";
import "./MainWindow.css";
// import CloseChatComponent from "../CloseChatComponent/CloseChatComponent";
import WelcomeScreen from "../WelcomeScreenComponent/WelcomeScreenComponent";

class MainWindow extends Component {
  constructor(props) {
    super(props);
    let size =
      window.parent != null
        ? { height: window.parent.outerHeight, width: window.parent.outerWidth }
        : { height: window.outerHeight, width: window.outerWidth };
    const initialHeight = 570; // "60%";
    var locale = ENGLISH;

    this.WebChatRef = React.createRef();

    // if (!!props.searchParameters["locale"])
    //   if (props.searchParameters["locale"].indexOf("ar") >= 0) locale = ARABIC; else locale = ENGLISH
    console.log(window.location.href);
    if (window.location.href.indexOf("en") >= 0) {
      locale = ENGLISH;
      // localStorage.setItem("lang", "en");
    } else if (window.location.href.indexOf("ar") >= 0) {
      locale = ARABIC;
      localStorage.setItem("lang", "ar");
    } else {
      //default lang
      locale = ENGLISH;
      localStorage.setItem("lang", "en");
    }

    this.state = {
      token: null,
      language: locale,
      welcomedUser: true,
      chatWindowHeight: initialHeight,
      height: initialHeight,
      initialHeight: initialHeight,
      noOfbuttonPressed: 0,
      showedIntroCard: false,
      size: size,
      webChatConfiguration: "",
      soundMuted: false,
      webSpeechPonyfillFactory: null,
      finishedLoading: false,
      isUserLogged: false,
      queueData: null,
      disabled: true,
    };
  }

  componentDidMount = async () => {
    if (!this.state.webChatConfiguration) {
      const response = await fetch("./webChatConfiguration.json", {
        headers: {
          "Content-Type": APPLICATION_JSON,
          Accept: APPLICATION_JSON,
        },
      }).catch(function() {
        // Handle error if needed
        this.setState({ finishedLoading: true });
        return;
      });

      const data = await response.json();
      this.setState({ webChatConfiguration: data, finishedLoading: true });
    }
  };

  startBotWithLanguage = (language = ENGLISH) => {
    this.locale = language;
    // loadLang(language).then(lang => this.props.dispatch(loadLiterals(lang)));
    this.setState({ language: language }, () => {
      this.setState({ welcomedUser: true });
    });
    this.changeLanguage(language);
    loadLang(language).then((lang) => this.props.dispatch(loadLiterals(lang)));
  };

  handleWindowChangedHeight = () => {
    window.parent.dispatchEvent(new CustomEvent("ChatbotResizeNeeded"), {});
  };
  handleCloseButtonClicked = () => {
    window.parent.dispatchEvent(new CustomEvent("Minimize"), {});
  };

  // Handle Back
  handleBackButtonClick = () => {
    this.setState(
      { token: null, showedIntroCard: false, welcomedUser: false },
      () => {
        window.parent.dispatchEvent(new CustomEvent("ChatbotBackClicked"), {});
      }
    );

    this.handleDequeued(null);
    this.diconnect();
    this.navigateToWelcome();
  };
  handleShowedIntroCard = () => {
    this.setState({ showedIntroCard: true });
  };
  handleQueueDataRecieved = (data) => {
    this.setState({ queueData: data });
  };
  handleDequeued = (data) => {
    this.setState({ queueData: null });
  };

  handleRestartButtonClick = (event) => {
    setTimeout(() => {
      var lang = this.state.language;
      if (!!event && !!event.target && !!event.target.value) {
        lang = event.target.value;
      }
      this.setState(
        { token: null, showedIntroCard: false, welcomedUser: false },
        () => {
          window.parent.dispatchEvent(
            new CustomEvent("ChatbotRestartClicked", { detail: {} })
          );
          this.clearTokens();
          this.startBotWithLanguage(lang);
        }
      );
      // this.handleDequeued(null);
      //this.diconnect();
      this.showRefresh();
      this.checkQueuePosition();
    }, 100);
  };

  showRefresh = () => {
    this.WebChatRef.showRefresh();
  };

  handleSendTranscriptButtonClick = () => {
    this.WebChatRef.sendTranscript();
  };

  diconnect = () => {
    this.WebChatRef.disconnectChatbotHandler();
  };

  checkQueuePosition = () => {
    this.WebChatRef.checkQueuePosition();
  };

  handleSelectLanguageChanged = (event) => {
    this.handleRestartButtonClick(event);
  };
  changeLanguage = (language = ENGLISH) => {
    this.setState({ language: language });
  };
  updateDimensions = () => {
    let size =
      window.parent != null
        ? { height: window.parent.outerHeight, width: window.parent.outerWidth }
        : { height: window.outerHeight, width: window.outerWidth };
    this.setState({ size: size });
  };
  handleToggleMuteSound = () => {
    this.setState({ soundMuted: !this.state.soundMuted });
  };

  // Set User Logged
  setUserLogged = (lang) => {
    let isUserLogged = true;
    this.setState({ isUserLogged: isUserLogged });
    window.parent.dispatchEvent(
      new CustomEvent("ChangeChatWidth", { detail: { width: "450px" } }),
      {}
    );
  };

  // Clear Tokens
  // clearTokens = () => {
  clearTokens() {
    if (localStorage.getItem("botToken")) {
      localStorage.removeItem("botToken");
      localStorage.removeItem("preflightSent");
    }
  }

  // Navigate To Welcome
  navigateToWelcome = () => {
    let isUserLogged = false;
    this.setState({ isUserLogged: isUserLogged });
    this.clearTokens();
    window.parent.dispatchEvent(
      new CustomEvent("ChangeChatWidth", { detail: { width: "350px" } }),
      {}
    );
  };

  addPlaceholderInTextBox() {
    let textBox = document.querySelectorAll(
      '[data-id="webchat-sendbox-input"]'
    );
    if (textBox[0]) {
      textBox[0].placeholder = "Ask your question ...";
    }
  }

  componentDidUpdate() {
    if (!this.state.language.includes("ar")) this.addPlaceholderInTextBox();
  }

  render() {
    const {
      state: {
        token,
        welcomedUser,
        language,
        showedIntroCard,
        webChatConfiguration,
        finishedLoading,
        size,
        soundMuted,
        webSpeechPonyfillFactory,
        isUserLogged,
      },
      startBotWithLanguage,
      handleWindowChangedHeight,
      handleCloseButtonClicked,
      handleBackButtonClick,
      handleShowedIntroCard,
      handleQueueDataRecieved,
      handleDequeued,
      handleRestartButtonClick,
      handleSendTranscriptButtonClick,
      changeLanguage,
      handleSelectLanguageChanged,
      handleToggleMuteSound,
      setUserLogged,
      disconnectChatbotHandler,
      diconnect,
    } = this;
    let mainClassName = "chat-box";

    // var mainWindow = (webChatConfiguration.showWelcomeScreen ? (
    var mainWindow = !isUserLogged ? (
      <WelcomeScreen
        className={"welcomeScreen"}
        startBotWithLanguage={(lang) => startBotWithLanguage(lang)}
        onOpenChat={this.setUserLogged}
      />
    ) : (
      <div
        className={mainClassName}
        // dir={getSearchParameters().indexOf("ar") >= 0 ? "rtl" : "ltr"}
      >
        <WebChatHeader
          size={this.state.size}
          onWindowChangedHeight={handleWindowChangedHeight}
          onBackButtonClicked={handleBackButtonClick}
          onCloseButtonClicked={handleCloseButtonClicked}
          onRestartButtonClicked={handleRestartButtonClick}
          onSendTranscriptButtonClicked={handleSendTranscriptButtonClick}
          showedIntroCard={showedIntroCard}
          webChatConfiguration={webChatConfiguration}
          onSelectLanguageChanged={handleSelectLanguageChanged}
          onToggleMuteSound={handleToggleMuteSound}
          soundMuted={soundMuted}
          language={getSearchParameters(this.state.language)}
          changeLanguage={changeLanguage}
          queueData={this.state.queueData}
          disconnectChatbotHandler={diconnect}
        />
        <WebChat
          size={size}
          className={"web-chat"}
          token={token}
          language={getSearchParameters(this.state.language)}
          changeLanguage={changeLanguage}
          showedIntroCard={showedIntroCard}
          handleShowedIntroCard={handleShowedIntroCard}
          handleQueueDataRecieved={handleQueueDataRecieved}
          handleDequeued={handleDequeued}
          webSpeechPonyfillFactory={webSpeechPonyfillFactory}
          webChatConfiguration={webChatConfiguration}
          soundMuted={soundMuted}
          startBotWithLanguage={startBotWithLanguage}
          forwardedRef={(el) => (this.WebChatRef = el)}
        />
      </div>
    );
    return !finishedLoading ? <div></div> : mainWindow;
  }
}

const mapStateToProps = ({ literals }) => ({
  literals,
});

var getSearchParameters = (lang) => {
  var match,
    pl = /\+/g, // Regex for replacing addition symbol with a space
    search = /([^&=]+)=?([^&]*)/g,
    decode = function(s) {
      return decodeURIComponent(s.replace(pl, " "));
    },
    query = window.location.search.substring(1);

  var urlParams = {};
  while ((match = search.exec(query)))
    urlParams[decode(match[1])] = decode(match[2]);

  // if (!urlParams.locale)
  // 	return ENGLISH;

  // if (urlParams.locale.indexOf('ar') >= 0) {
  // 	return ARABIC
  // }

  // if (urlParams.locale.indexOf('en') >= 0) {
  // 	return ENGLISH
  // }
  urlParams.locale = lang ? lang : ENGLISH;
  document.getElementsByTagName("html")[0].lang =
    urlParams.locale.indexOf("ar") >= 0 ? "ar" : "en";
  var chatBox = document.getElementsByClassName("chat-box")[0];
  if (chatBox)
    chatBox.dir = urlParams.locale.indexOf("ar") >= 0 ? "rtl" : "ltr";
  return urlParams.locale;
};

export default connect(mapStateToProps)(MainWindow);
